import { TextProps, Text } from "@mantine/core"
import { ReactNode, useMemo } from "react"
import classes from './CText.module.scss';

export type CTextProps = TextProps & {
  children: ReactNode;
  justify?: boolean;
  type?: 'normal' | 'title'
}

export const CText = (props: CTextProps) => {
  const { type = 'normal', ...rest } = props;

  const preset = useMemo<TextProps>(() => {
    switch (type) {
      case 'normal':
        return {

        }
      case 'title':
        return {
          w: 600,
          fs: '1.2em'
        }
    }
  }, [type])

  return <Text {...preset} {...rest} />
}